/* eslint-disable no-console, import/imports-first, import/newline-after-import */

import version from '../../version'
console.info(`Lemonapt v${version}`)
import config from './config'

import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueDocumentTitlePlugin from 'vue-document-title-plugin'
import ElementUI from 'element-ui'
import Socket from './websocket'

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(ElementUI)
Vue.use(Socket)
Vue.http.options.root = config.api_root_url

import './utils/ployfill'
// Custom
import { utils, moments } from './utils'
import Cookies from 'js-cookie'
import User from './user'
import * as Defines from './defines'
import Permission from './permission'
import Native from './native'
import MediaQuery from './media_query'
import Templater from './templater_requester'
import { Formatters } from './modules'

Vue.prototype.$moment = moments
Vue.prototype.$utils = utils
Vue.prototype.$config = config
Vue.prototype.$user = User.load()
Vue.prototype.$cookies = Cookies
Vue.prototype.$defines = Defines
Vue.prototype.$templater = Templater
Vue.prototype.$formatters = Formatters
Vue.prototype.$permission = Permission
Vue.prototype.$native = Native
Vue.prototype.$media = MediaQuery

// Vue components
import App from './App.vue'
import Storage from './store/index'

// Assets
import './assets/style/normalize.css'
import './assets/style/element-theme/index.css'
import 'semantic-ui-css/semantic.css'
import './assets/style/index.less'
require.context('../static/', true)

// Store
const store = new Vuex.Store(Storage)

// Routers
import Routers from './routers'

const router = new VueRouter({ routes: Routers })
Vue.use(VueDocumentTitlePlugin, router, { defTitle: config.website_title, filter: title => title + config.website_title })

import Gotos from './utils/gotos'
Gotos(router, store)

// ProgressBar
import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
  color: '#fff',
  failedColor: 'red',
  height: '2px',
})

// App
const app = window.app = new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  store,
  router,
  // socket
}).$mount('#app')

app.$templater.set_middleware((data) => {
  try {
    if (app.$user && app.$user.is_logined())
      data._operator = app.$user.get_name()
    /* eslint-disable no-empty */
  } catch (e) {}
  return data
})

export default app



// WEBPACK FOOTER //
// ./client/src/main.js